module.exports = __webpack_public_path__ + "static/media/habanero pepper.2cdd1450.jpg";